import * as React from 'react'

import { ENTITY_TYPES } from '@sales-center/common'
import { ServiceLocationCardDetail } from '@user/components/Services'

import { useDataExisting } from './useDataExisting'
import { Panel, CircularProgress } from '../atoms'

export type ServicesAddedProps = {
  entityId: number
  entityType: ENTITY_TYPES
}

export function ServicesAddedEdit(props: ServicesAddedProps) {
  const { title, loading, serviceLocations, serviceFrequencies } =
    useDataExisting(props)

  return (
    <Panel icon="service" title={title}>
      {loading ? (
        <CircularProgress />
      ) : (
        serviceLocations.map((l) => (
          <ServiceLocationCardDetail
            disabled
            readOnly
            key={l.id}
            location={l}
            disableGrayBg
            defaultExpanded
            loading={false}
            localMode={false}
            entityType={ENTITY_TYPES.Opportunity}
            serviceFrequencies={serviceFrequencies}
            variant="old"
          />
        ))
      )}
    </Panel>
  )
}
